// ═══════════════════════════════════════
// GABIRANO.CH v13.8 – Optimized Interactive Effects
// ═══════════════════════════════════════

// ── CUSTOM CURSOR (only on desktop with fine pointer) ──
const cursorDot = document.getElementById('cursor-dot');
const cursorRing = document.getElementById('cursor-ring');
if (window.matchMedia('(pointer: fine)').matches && cursorDot && cursorRing) {
  document.addEventListener('mousemove', e => {
    cursorDot.style.left = e.clientX - 4 + 'px';
    cursorDot.style.top = e.clientY - 4 + 'px';
    cursorRing.style.left = e.clientX + 'px';
    cursorRing.style.top = e.clientY + 'px';
  });
  document.querySelectorAll('a, button, .tour-btn, .social-card, .article-card').forEach(el => {
    el.addEventListener('mouseenter', () => cursorRing.classList.add('hovering'));
    el.addEventListener('mouseleave', () => cursorRing.classList.remove('hovering'));
  });
}

// ── SCROLL REVEAL ANIMATIONS ──
function addRevealClasses() {
  document.querySelectorAll('.section-title, .section-label, .red-line').forEach(el => el.classList.add('reveal'));
  document.querySelectorAll('.tour-card').forEach((el, i) => {
    el.classList.add('reveal');
    el.style.transitionDelay = (i * 0.08) + 's';
  });
  const socialGrid = document.querySelector('.social-grid');
  if (socialGrid) socialGrid.classList.add('stagger-children');
  const aboutPhoto = document.querySelector('.about-photo');
  const aboutText = document.querySelector('.about-text');
  if (aboutPhoto) aboutPhoto.classList.add('reveal-left');
  if (aboutText) aboutText.classList.add('reveal-right');
  const bookingForm = document.querySelector('.booking-form-wrapper');
  if (bookingForm) bookingForm.classList.add('reveal');
}
addRevealClasses();

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
    }
  });
}, { threshold: 0.05, rootMargin: '0px 0px -20px 0px' });

document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .stagger-children').forEach(el => observer.observe(el));

// ── BATCHED SCROLL HANDLER (rAF – no layout thrashing) ──
const progressBar = document.getElementById('scroll-progress');
const heroContent = document.querySelector('.hero-content');
const heroPhotoImg = document.querySelector('.hero-photo img');
const nav = document.querySelector('.nav');
let scrollTicking = false;

function updateScrollEffects() {
  const scroll = window.scrollY;
  const vh = window.innerHeight;
  const docHeight = document.documentElement.scrollHeight - vh;

  // Scroll progress bar
  if (progressBar && docHeight > 0) {
    progressBar.style.width = (scroll / docHeight) * 100 + '%';
  }

  // Hero parallax (only above fold, only desktop)
  if (window.innerWidth > 768) {
    if (heroContent && scroll < vh) {
      heroContent.style.transform = 'translateY(' + (scroll * 0.3) + 'px)';
      heroContent.style.opacity = 1 - (scroll / vh) * 0.8;
    }
    if (heroPhotoImg && scroll < vh) {
      heroPhotoImg.style.transform = 'scale(' + (1 + scroll * 0.0003) + ') translateY(' + (scroll * 0.1) + 'px)';
    }
  }

  // Nav shrink
  if (nav) {
    if (scroll > 100) {
      nav.style.height = '56px';
      nav.style.background = 'rgba(14,14,14,0.98)';
    } else {
      nav.style.height = '72px';
      nav.style.background = 'rgba(14,14,14,0.95)';
    }
  }

  scrollTicking = false;
}

window.addEventListener('scroll', function() {
  if (!scrollTicking) {
    scrollTicking = true;
    requestAnimationFrame(updateScrollEffects);
  }
}, { passive: true });

// ── COUNTER ANIMATION ──
function animateCounter(el, target, suffix) {
  suffix = suffix || '';
  var duration = 1500;
  var start = performance.now();
  var isFloat = target % 1 !== 0;

  function update(now) {
    var elapsed = now - start;
    var progress = Math.min(elapsed / duration, 1);
    var eased = 1 - Math.pow(1 - progress, 3);
    var current;
    if (isFloat) {
      var val = Math.max(0, target * eased);
      current = val.toFixed(2);
      if (current === '-0.00') current = '0.00';
    } else {
      current = Math.max(0, Math.floor(target * eased));
    }
    el.textContent = current + suffix;
    if (progress < 1) requestAnimationFrame(update);
  }
  requestAnimationFrame(update);
}

// Counter animation only on desktop
if (window.innerWidth > 768) {
  var counterObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting && !entry.target.dataset.counted) {
        entry.target.dataset.counted = 'true';
        var text = entry.target.textContent;
        if (text.includes('2.10')) animateCounter(entry.target, 2.10, 'm');
        else if (text.includes('399k')) animateCounter(entry.target, 399, 'k');
        else if (text.includes('50+')) animateCounter(entry.target, 50, '+');
      }
    });
  }, { threshold: 0.5 });
  document.querySelectorAll('.stat-number, .hero-stat-number').forEach(function(el) { counterObserver.observe(el); });
}

// ── CONFETTI ON TICKET CLICK ──
var confettiCanvas = document.getElementById('confetti-canvas');
if (confettiCanvas) {
  var confettiCtx = confettiCanvas.getContext('2d');
  var confettiPieces = [];
  var confettiAnimating = false;

  function resizeConfetti() {
    confettiCanvas.width = window.innerWidth;
    confettiCanvas.height = window.innerHeight;
  }
  resizeConfetti();
  window.addEventListener('resize', resizeConfetti, { passive: true });

  function launchConfetti(x, y) {
    var colors = ['#E50914', '#FFFFFF', '#0E0E0E', '#FFD700', '#FF6B6B'];
    var emojis = ['🎤', '🎉', '🎫', '🇨🇭', '😂', '🔥'];

    for (var i = 0; i < 60; i++) {
      var angle = (Math.PI * 2 * i) / 60;
      var velocity = 4 + Math.random() * 8;
      confettiPieces.push({
        x: x, y: y,
        vx: Math.cos(angle) * velocity * (0.5 + Math.random()),
        vy: Math.sin(angle) * velocity * (0.5 + Math.random()) - 4,
        size: 4 + Math.random() * 6,
        color: colors[Math.floor(Math.random() * colors.length)],
        rotation: Math.random() * 360,
        rotSpeed: (Math.random() - 0.5) * 10,
        life: 1,
        decay: 0.01 + Math.random() * 0.015,
        type: Math.random() > 0.8 ? 'emoji' : 'rect',
        emoji: emojis[Math.floor(Math.random() * emojis.length)]
      });
    }
    if (!confettiAnimating) {
      confettiAnimating = true;
      animateConfetti();
    }
  }

  function animateConfetti() {
    confettiCtx.clearRect(0, 0, confettiCanvas.width, confettiCanvas.height);
    confettiPieces = confettiPieces.filter(function(p) { return p.life > 0; });

    confettiPieces.forEach(function(p) {
      p.x += p.vx;
      p.y += p.vy;
      p.vy += 0.15;
      p.rotation += p.rotSpeed;
      p.life -= p.decay;

      confettiCtx.save();
      confettiCtx.translate(p.x, p.y);
      confettiCtx.rotate(p.rotation * Math.PI / 180);
      confettiCtx.globalAlpha = p.life;

      if (p.type === 'emoji') {
        confettiCtx.font = p.size * 2.5 + 'px serif';
        confettiCtx.fillText(p.emoji, 0, 0);
      } else {
        confettiCtx.fillStyle = p.color;
        confettiCtx.fillRect(-p.size/2, -p.size/2, p.size, p.size * 0.6);
      }
      confettiCtx.restore();
    });

    if (confettiPieces.length > 0) {
      requestAnimationFrame(animateConfetti);
    } else {
      confettiAnimating = false;
      confettiCtx.clearRect(0, 0, confettiCanvas.width, confettiCanvas.height);
    }
  }

  // Attach confetti to ticket buttons
  document.querySelectorAll('.tour-btn:not(.tour-btn-soon), .nav-cta').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var rect = btn.getBoundingClientRect();
      launchConfetti(rect.left + rect.width / 2, rect.top + rect.height / 2);
    });
  });
}

// ── 3D TILT ON CARDS (only on desktop) ──
if (window.matchMedia('(pointer: fine)').matches) {
  document.querySelectorAll('.social-card, .article-card').forEach(function(card) {
    card.addEventListener('mousemove', function(e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      card.style.transform = 'perspective(600px) rotateY(' + (x * 8) + 'deg) rotateX(' + (-y * 8) + 'deg) translateY(-4px)';
    });
    card.addEventListener('mouseleave', function() {
      card.style.transform = 'perspective(600px) rotateY(0) rotateX(0) translateY(0)';
      card.style.transition = 'transform 0.5s ease';
    });
    card.addEventListener('mouseenter', function() {
      card.style.transition = 'transform 0.1s ease';
    });
  });
}

// ── FLOATING EMOJIS ON 2.10m CLICK ──
var heroStat = document.querySelector('.hero-stat-number');
if (heroStat) {
  heroStat.style.cursor = 'pointer';
  heroStat.addEventListener('click', function(e) {
    var emojis = ['📏', '🦒', '🏀', '🗼', '😂', '🎤'];
    for (var i = 0; i < 6; i++) {
      (function(idx) {
        setTimeout(function() {
          var emoji = document.createElement('div');
          emoji.className = 'floating-emoji';
          emoji.textContent = emojis[idx % emojis.length];
          emoji.style.left = (e.clientX + (Math.random() - 0.5) * 100) + 'px';
          emoji.style.top = e.clientY + 'px';
          document.body.appendChild(emoji);
          setTimeout(function() { emoji.remove(); }, 2000);
        }, idx * 100);
      })(i);
    }
  });
}

// ── KONAMI CODE EASTER EGG ──
var konamiSequence = [];
var konamiCode = ['ArrowUp','ArrowUp','ArrowDown','ArrowDown','ArrowLeft','ArrowRight','ArrowLeft','ArrowRight','b','a'];
var konamiOverlay = document.getElementById('konami-overlay');

if (konamiOverlay) {
  document.addEventListener('keydown', function(e) {
    if (konamiOverlay.classList.contains('active') && e.key === 'Escape') {
      konamiOverlay.classList.remove('active');
      return;
    }
    konamiSequence.push(e.key);
    if (konamiSequence.length > 10) konamiSequence.shift();
    if (konamiSequence.join(',') === konamiCode.join(',')) {
      konamiOverlay.classList.add('active');
      if (typeof launchConfetti === 'function') {
        launchConfetti(window.innerWidth / 2, window.innerHeight / 2);
      }
      konamiSequence = [];
    }
  });
}

// ── MAGNETIC BUTTONS (only desktop) ──
if (window.matchMedia('(pointer: fine)').matches) {
  document.querySelectorAll('.btn-primary, .btn-secondary, .nav-cta').forEach(function(btn) {
    btn.classList.add('magnetic-btn');
    btn.addEventListener('mousemove', function(e) {
      var rect = btn.getBoundingClientRect();
      var x = e.clientX - rect.left - rect.width / 2;
      var y = e.clientY - rect.top - rect.height / 2;
      btn.style.transform = 'translate(' + (x * 0.2) + 'px, ' + (y * 0.2) + 'px)';
    });
    btn.addEventListener('mouseleave', function() {
      btn.style.transform = 'translate(0, 0)';
    });
  });
}

// ── TEXT SCRAMBLE ON HERO TITLE HOVER (only desktop) ──
if (window.matchMedia('(pointer: fine)').matches) {
  var heroTitle = document.querySelector('.hero-title');
  if (heroTitle) {
    var originalText = heroTitle.innerHTML;
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$%&';

    heroTitle.addEventListener('mouseenter', function() {
      var iteration = 0;
      var text = 'GABIRANO';
      var interval = setInterval(function() {
        heroTitle.innerHTML = text.split('').map(function(char, i) {
          if (i < iteration) {
            if (i === 5) return '<span class="accent">A</span>';
            return char;
          }
          return chars[Math.floor(Math.random() * chars.length)];
        }).join('');
        iteration += 0.5;
        if (iteration >= text.length) {
          clearInterval(interval);
          heroTitle.innerHTML = originalText;
        }
      }, 40);
    });
  }
}

// ── LOGO CLICK EASTER EGG ──
var logoClicks = 0;
var logo = document.querySelector('.nav-logo');
if (logo) {
  logo.addEventListener('click', function(e) {
    e.preventDefault();
    logoClicks++;
    if (logoClicks === 5) {
      document.body.style.transition = 'transform 0.5s';
      document.body.style.transform = 'rotate(180deg)';
      setTimeout(function() {
        document.body.style.transform = 'rotate(360deg)';
        setTimeout(function() { document.body.style.transform = ''; }, 500);
      }, 1000);
      logoClicks = 0;
    }
    if (logoClicks >= 3 && logoClicks < 5) {
      var dot = logo.querySelector('span');
      if (dot) {
        dot.style.transition = 'transform 0.3s';
        dot.style.transform = 'scale(' + (1 + logoClicks * 0.5) + ')';
        setTimeout(function() { dot.style.transform = 'scale(1)'; }, 300);
      }
    }
  });
}

// ── HAMBURGER MENU ──
var hamburger = document.getElementById('nav-hamburger');
var navLinks = document.getElementById('nav-links');
var navOverlay = document.getElementById('nav-overlay');
if (hamburger && navLinks && navOverlay) {
  hamburger.addEventListener('click', function() {
    hamburger.classList.toggle('active');
    navLinks.classList.toggle('open');
    navOverlay.classList.toggle('open');
    document.body.style.overflow = navLinks.classList.contains('open') ? 'hidden' : '';
  });
  navOverlay.addEventListener('click', function() {
    hamburger.classList.remove('active');
    navLinks.classList.remove('open');
    navOverlay.classList.remove('open');
    document.body.style.overflow = '';
  });
  navLinks.querySelectorAll('a').forEach(function(link) {
    link.addEventListener('click', function() {
      hamburger.classList.remove('active');
      navLinks.classList.remove('open');
      navOverlay.classList.remove('open');
      document.body.style.overflow = '';
    });
  });
}

// ── COUNTDOWN TIMER ──
(function() {
  var shows = [
    { date: '2026-03-28T20:00:00+01:00', city: 'Frauenfeld', url: 'https://www.ticketcorner.ch/event/gabirano-2m10-2026-casino-frauenfeld-21179351/' },
    { date: '2026-04-23T20:00:00+02:00', city: 'Amriswil', url: 'https://www.ticketcorner.ch/event/gabirano-2m10-2026-kulturforum-21179265/' },
    { date: '2026-04-29T20:00:00+02:00', city: 'Zürich', url: 'https://www.ticketcorner.ch/event/gabirano-2m10-2026-plaza-21237953/' },
    { date: '2026-05-12T20:00:00+02:00', city: 'Winterthur', url: 'https://casinotheater.eventim-inhouse.de/webshop/webticket/seatmap?eventId=3476&el=true' },
    { date: '2026-05-27T20:00:00+02:00', city: 'Basel', url: '#tour' },
    { date: '2026-09-09T20:00:00+02:00', city: 'Heerbrugg', url: 'https://kinomadlen.ch/programmuebersicht/movie/gabriano-2m-10/' },
    { date: '2026-10-21T20:00:00+02:00', city: 'Zürich', url: 'https://www.ticketcorner.ch/event/gabirano-2m10-2026-plaza-21237952/' },
    { date: '2026-10-29T20:00:00+02:00', city: 'Wil', url: 'https://www.ticketcorner.ch/event/gabirano-2m10-2026-tonhalle-wil-21179057/' },
    { date: '2026-11-04T20:00:00+01:00', city: 'Bern', url: 'https://www.ticketcorner.ch/event/gabirano-2m10-2026-eventlokal-sternensaal-21335626/' },
    { date: '2026-11-26T20:00:00+01:00', city: 'Herisau', url: 'https://www.ticketcorner.ch/event/gabirano-2m10-2026-casino-herisau-21212388/' }
  ];

  var cityEl = document.getElementById('countdown-city');
  var daysEl = document.getElementById('cd-days');
  var hoursEl = document.getElementById('cd-hours');
  var minsEl = document.getElementById('cd-mins');
  var banner = document.getElementById('countdown-banner');
  var ticketBtn = document.querySelector('.countdown-btn');

  function updateCountdown() {
    var now = new Date();
    var next = null;
    for (var i = 0; i < shows.length; i++) {
      if (new Date(shows[i].date) > now) { next = shows[i]; break; }
    }
    if (!next) {
      if (banner) banner.style.display = 'none';
      return;
    }
    if (cityEl) cityEl.textContent = next.city;
    if (ticketBtn) {
      ticketBtn.href = next.url;
      if (next.url.startsWith('http')) ticketBtn.target = '_blank';
      else ticketBtn.removeAttribute('target');
    }
    var diff = new Date(next.date) - now;
    var days = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var mins = Math.floor((diff % 3600000) / 60000);
    if (daysEl) daysEl.textContent = days;
    if (hoursEl) hoursEl.textContent = hours < 10 ? '0' + hours : hours;
    if (minsEl) minsEl.textContent = mins < 10 ? '0' + mins : mins;
  }

  updateCountdown();
  setInterval(updateCountdown, 60000);
})();

// ── STICKY TICKET BUTTON (show after hero scroll) ──
(function() {
  var sticky = document.getElementById('sticky-ticket');
  var hero = document.querySelector('.hero');
  if (sticky && hero && window.innerWidth <= 768) {
    var stickyTicking = false;
    window.addEventListener('scroll', function() {
      if (!stickyTicking) {
        stickyTicking = true;
        requestAnimationFrame(function() {
          var heroBottom = hero.getBoundingClientRect().bottom;
          sticky.style.display = heroBottom < 0 ? 'block' : 'none';
          stickyTicking = false;
        });
      }
    }, { passive: true });
  }
})();

// ── NEWSLETTER FORM (Shopify Customer API) ──
(function() {
  var form = document.getElementById('newsletter-form');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = form.querySelector('.newsletter-btn');
      var formData = new FormData(form);
      fetch(form.action, {
        method: 'POST',
        body: formData
      }).then(function() {
        if (btn) {
          btn.textContent = 'Merci! ✓';
          btn.style.background = '#22c55e';
          setTimeout(function() {
            btn.textContent = 'Dabei sein →';
            btn.style.background = '';
          }, 3000);
        }
      }).catch(function() {
        if (btn) {
          btn.textContent = 'Fehler – nochmal versuchen';
          btn.style.background = '#e63232';
          setTimeout(function() {
            btn.textContent = 'Dabei sein →';
            btn.style.background = '';
          }, 3000);
        }
      });
    });
  }
})();

console.log('%c🎤 GABIRANO.CH v13.8', 'font-size:24px;font-weight:900;color:#E50914;');
console.log('%cOptimized – PageSpeed fixes applied', 'font-size:12px;color:#999;');
